<div class="dvb-kapazitaet-header">
    <p>
        <span data-translate="{{vm.kapazitaetTitle}}"
              data-translate-value-preposition="{{vm.temporalPrepositionKey | translate}}"></span>
        <span ng-bind="vm.wochenKapazitaet.gueltigAb | amDateFormat: 'D.M.YYYY'"></span>
    </p>
</div>
